const BASE = '/api';

function getToken() {
  return localStorage.getItem('token');
}

function headers() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getToken()}`
  };
}

export async function login(username, password) {
  const res = await fetch(`${BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });
  const data = await res.json();
  if (data.token) localStorage.setItem('token', data.token);
  return data;
}

export async function getUsers() {
  const res = await fetch(`${BASE}/users`, { headers: headers() });
  return res.json();
}

export async function createUser(userData) {
  const res = await fetch(`${BASE}/users`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(userData)
  });
  return res.json();
}

export async function updateUser(id, userData) {
  const res = await fetch(`${BASE}/users/${id}`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(userData)
  });
  return res.json();
}

export async function deleteUser(id) {
  const res = await fetch(`${BASE}/users/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
}

export async function activateUser(id) {
  const res = await fetch(`${BASE}/users/${id}/activate`, {
    method: 'POST',
    headers: headers()
  });
  return res.json();
}

export async function resetTraffic(id) {
  const res = await fetch(`${BASE}/users/${id}/reset-traffic`, {
    method: 'POST',
    headers: headers()
  });
  return res.json();
}

export async function resetSub(id) {
  const res = await fetch(`${BASE}/users/${id}/reset-sub`, {
    method: 'POST',
    headers: headers()
  });
  return res.json();
}

export function logout() {
  localStorage.removeItem('token');
}
